import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import BackToTop from '@/components/feature/BackToTop';
import FacebookFollow from '@/components/feature/FacebookFollow';
import RoomsHero from './components/RoomsHero';
import RoomsIntro from './components/RoomsIntro';
import RoomsSection from './components/RoomsSection';
import RoomsAmenities from './components/RoomsAmenities';
import RoomsGallery from './components/RoomsGallery';
import RoomsBooking from './components/RoomsBooking';

export default function Rooms() {
  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, []);

  return (
    <>
      <Navbar />

      <main>
        <RoomsHero />
        <RoomsIntro />
        <RoomsSection />
        <RoomsAmenities />
        <RoomsGallery />
        <RoomsBooking />
        <FacebookFollow />
      </main>

      <Footer />
      <BackToTop />
    </>
  );
}